export default function addBrTagBeforeText(text, searchString) {
    const position = text.indexOf(searchString);
    if (position !== -1) {
      const beforeText = text.slice(0, position);
      const afterText = text.slice(position);
  
      const htmlText = `${beforeText}\n ${afterText}`;
      return htmlText;
    } else {
      return text; 
    }
}



